module.exports = __webpack_public_path__ + "img/tailCoin.ebf0b101.svg";